import React, { useRef, useEffect } from 'react';
import { useLocation, Switch, HashRouter } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';
import Email from './views/Email';
import Resume from './views/Resume';
import Blog from './views/Blog';
import BlogHelloWorld from './views/BlogHelloWorld';

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <HashRouter>
      <ScrollReveal
        ref={childRef}
        children={() => (
          <Switch>
            <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
            <AppRoute exact path="/Email" component={Email} layout={LayoutDefault} />
            <AppRoute exact path="/Resume" component={Resume} layout={LayoutDefault} />
            <AppRoute exact path="/Blog" component={Blog} layout={LayoutDefault} />
            <AppRoute exact path="/BlogHelloWorld" component={BlogHelloWorld} layout={LayoutDefault} />
          </Switch>
        )} />
    </HashRouter>
  );
}

export default App;
